module.exports = __webpack_public_path__ + "static/media/levels_1_1.b64399e0.svg";